import { render, staticRenderFns } from "./updateOrder.vue?vue&type=template&id=7dd00e97&"
import script from "./updateOrder.vue?vue&type=script&lang=js&"
export * from "./updateOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports